import React from 'react';
import { CompanyCard, Metric } from './CompanyCard';
import { ActivityIcon, StarIcon } from 'lucide-react';
export function ExecutiveDashboard() {
  const polytecMetrics: Metric[] = [{
    label: 'Umsatz',
    value: '€706M',
    status: 'neutral',
    trend: 'none'
  }, {
    label: 'EBIT',
    value: '€3.9M',
    previousValue: '-€6.7M',
    status: 'positive',
    trend: 'up'
  }, {
    label: 'Eigenkapitalquote',
    value: '28%',
    status: 'neutral',
    trend: 'flat'
  }, {
    label: 'Mitarbeiter',
    value: '~4.200',
    status: 'neutral',
    trend: 'flat'
  }];
  const elringKlingerMetrics: Metric[] = [{
    label: 'Umsatz',
    value: '€1.6Mrd',
    status: 'neutral',
    trend: 'none'
  }, {
    label: 'EBIT',
    value: '-€150M',
    status: 'negative',
    trend: 'down'
  }, {
    label: 'Eigenkapitalquote',
    value: '22%',
    status: 'warning',
    trend: 'flat'
  }, {
    label: 'Mitarbeiter',
    value: '8.736',
    previousValue: '9.589',
    status: 'negative',
    trend: 'down'
  }];
  const roechlingMetrics: Metric[] = [{
    label: 'Umsatz',
    value: '€2.6Mrd',
    status: 'positive',
    trend: 'none'
  }, {
    label: 'EBIT',
    value: '~€100M',
    status: 'positive',
    trend: 'flat'
  }, {
    label: 'Eigenkapitalquote',
    value: '43%',
    status: 'positive',
    trend: 'flat'
  }, {
    label: 'Mitarbeiter',
    value: '~11.500',
    status: 'neutral',
    trend: 'flat'
  }];
  const wocoMetrics: Metric[] = [{
    label: 'Umsatz',
    value: '~€800M',
    status: 'neutral',
    trend: 'none'
  }, {
    label: 'EBIT',
    value: '-€15.5M',
    status: 'negative',
    trend: 'flat'
  }, {
    label: 'Eigenkapitalquote',
    value: '18%',
    status: 'negative',
    trend: 'flat'
  }, {
    label: 'Mitarbeiter',
    value: '~5.000',
    status: 'neutral',
    trend: 'flat'
  }];
  return <section className="mb-16" data-id="element-36">
      <div className="flex items-center gap-3 mb-6" data-id="element-37">
        <div className="bg-tech-grey text-white p-2 rounded-lg" data-id="element-38">
          <ActivityIcon className="w-5 h-5" data-id="element-39" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-tech-grey" data-id="element-40">
          Polytec vs. Wettbewerber
        </h2>
      </div>

      {/* Polytec highlighted card */}
      <div className="mb-6" data-id="element-41">
        <div className="relative" data-id="element-42">
          <div className="absolute -top-2 left-4 bg-passion-red text-white px-3 py-0.5 rounded-full text-xs font-heading font-bold uppercase tracking-wider flex items-center gap-1.5 z-10" data-id="element-43">
            <StarIcon className="w-3 h-3" data-id="element-44" />
            Polytec
          </div>
          <div className="border-2 border-passion-red rounded-xl" data-id="element-45">
            <CompanyCard companyName="Polytec" metrics={polytecMetrics} data-id="element-46" />
          </div>
        </div>
      </div>

      {/* Competitor cards */}
      <p className="font-body text-sm text-tech-grey-50 uppercase tracking-wider font-semibold mb-4" data-id="element-47">
        Wettbewerber
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-48">
        <CompanyCard companyName="ElringKlinger" metrics={elringKlingerMetrics} data-id="element-49" />
        <CompanyCard companyName="Röchling" metrics={roechlingMetrics} data-id="element-50" />
        <CompanyCard companyName="Woco" metrics={wocoMetrics} data-id="element-51" />
      </div>
    </section>;
}